<template>
  <div>
    <div class="addrestip">
      <span
        >請到電商平臺添加我們的倉庫地址進行購物，注意保留收貨地址中的會員號數位，以免造成包裹歸屬問題</span
      >
    </div>
    <div class="addrwsconw" v-for="(item, index) in wareHoseList" :key="index">
      <md-field v-if="item.name">
        <div
          style="text-align: left;font-size: 0.4rem;font-weight: 500;margin-bottom: 0.1rem"
        >
          {{ item.name }}【{{ countryName }}】
        </div>
        <md-cell-item title="收件人" :brief="item.receiver">
          <span
            slot="right"
            style="font-size: 0.32rem;color: #56B0FE"
            @click="copy(item.receiver)"
            >複製</span
          >
        </md-cell-item>
        <md-cell-item title="聯繫電話" :brief="item.mobile">
          <span
            slot="right"
            style="font-size: 0.32rem;color: #56B0FE"
            @click="copy(item.mobile)"
            >複製</span
          >
        </md-cell-item>
        <md-cell-item title="收件地址" :brief="item.address">
          <span
            slot="right"
            style="font-size: 0.32rem;color: #56B0FE"
            @click="copy(item.address)"
            >複製</span
          >
        </md-cell-item>
        <md-cell-item title="郵編" :brief="item.postalCode">
          <span
            slot="right"
            style="font-size: 0.32rem;color: #56B0FE"
            @click="copy(item.postalCode)"
            >複製</span
          >
        </md-cell-item>
        <p class="tips">如電商平臺可以智慧識別地址，您可以複製以下資訊</p>
        <md-cell-item title="拼接地址" :brief="item.detail">
          <span
            slot="right"
            style="font-size: 0.32rem;color: #56B0FE"
            @click="copy(item.detail)"
            >複製</span
          >
        </md-cell-item>
      </md-field>
    </div>
  </div>
</template>

<script>
import { Field, CellItem, Toast } from "mand-mobile";
export default {
  name: "address",
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem
  },
  data() {
    return {
      countryName: "",
      wareHoseList: [],
      // par: { name: "" }
    };
  },
  activated() {
    this.buildAddress();
  },
  methods: {
    buildAddress() {
      const par = {
        countryId: this.$route.query.id
      };
      this.http.APIASK(this.ports.buildAddress, "get", par).then(res => {
        // this.par = res;
        this.wareHoseList = res;
        this.countryName = JSON.parse(
          localStorage.getItem("userinfoMobie")
        ).disVo.name;
      });
    },
    copy(name) {
      const url = name;
      const oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.remove();
      Toast.succeed("複製成功");
    }
  }
};
</script>

<style lang="less">
.addrestip {
  width: 100%;
  text-align: center;
  background-color: #f7898a;
  color: white;
  font-size: 0.24rem;
  margin-bottom: 0.3rem;
  height: 1rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    margin: 0 0.2rem;
  }
}
.addrwsconw {
  width: 95%;
  margin: 0.5rem auto;
  .md-field {
    border-radius: 0.2rem;
  }
  .md-cell-item-title {
    text-align: left;
  }
  .md-cell-item-body.multilines {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }
  .md-cell-item-brief {
    padding: 0.1rem 0;
    font-size: 0.3rem;
    text-align: left;
  }
  .tips {
    font-size: 0.24rem;
    text-align: left;
    margin: 0.2rem 0;
    color: #e51c23;
  }
  .tip {
    font-size: 0.2rem;
    padding-top: 0.2rem;
    color: #e51c23;
    text-align: left;
  }
  .md-cell-item-body:before {
    content: "";
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }
}
</style>
